export default __webpack_public_path__ + "static/media/080_finish_bad.13451ba2.mp4";